
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-terms",
      function () {
        return require("private-next-pages/use-terms/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/use-terms"])
      });
    }
  